// tslint:disable
/**
 * diagnosis-2020
 * 診断&ステップ配信サービス
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __assign, __extends } from "tslib";
import * as globalImportUrl from 'url';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, BaseAPI, RequiredError } from './base';
/**
 * AnswerApi - axios parameter creator
 * @export
 */
export var AnswerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count answer by search conditions
         * @summary count answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAnswer: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/answers/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create answer
         * @summary create answer
         * @param {ModelAnswer} body Answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswer: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createAnswer.');
            }
            var localVarPath = "/answer";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete answer
         * @summary delete answer
         * @param {number} id AnswerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswer: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteAnswer.');
            }
            var localVarPath = "/answer/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get answer
         * @summary get answer
         * @param {number} id AnswerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswer: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getAnswer.');
            }
            var localVarPath = "/answer/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch answer
         * @summary patch answer
         * @param {number} id AnswerID
         * @param {ModelAnswer} body Answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAnswer: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchAnswer.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchAnswer.');
            }
            var localVarPath = "/answer/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search answer by search conditions
         * @summary search answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnswer: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/answers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update answer
         * @summary update answer
         * @param {number} id AnswerID
         * @param {ModelAnswer} body Answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswer: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateAnswer.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateAnswer.');
            }
            var localVarPath = "/answer/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnswerApi - functional programming interface
 * @export
 */
export var AnswerApiFp = function (configuration) {
    return {
        /**
         * count answer by search conditions
         * @summary count answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAnswer: function (options) {
            var localVarAxiosArgs = AnswerApiAxiosParamCreator(configuration).countAnswer(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create answer
         * @summary create answer
         * @param {ModelAnswer} body Answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswer: function (body, options) {
            var localVarAxiosArgs = AnswerApiAxiosParamCreator(configuration).createAnswer(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete answer
         * @summary delete answer
         * @param {number} id AnswerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswer: function (id, options) {
            var localVarAxiosArgs = AnswerApiAxiosParamCreator(configuration).deleteAnswer(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get answer
         * @summary get answer
         * @param {number} id AnswerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswer: function (id, options) {
            var localVarAxiosArgs = AnswerApiAxiosParamCreator(configuration).getAnswer(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch answer
         * @summary patch answer
         * @param {number} id AnswerID
         * @param {ModelAnswer} body Answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAnswer: function (id, body, options) {
            var localVarAxiosArgs = AnswerApiAxiosParamCreator(configuration).patchAnswer(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search answer by search conditions
         * @summary search answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnswer: function (options) {
            var localVarAxiosArgs = AnswerApiAxiosParamCreator(configuration).searchAnswer(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update answer
         * @summary update answer
         * @param {number} id AnswerID
         * @param {ModelAnswer} body Answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswer: function (id, body, options) {
            var localVarAxiosArgs = AnswerApiAxiosParamCreator(configuration).updateAnswer(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * AnswerApi - factory interface
 * @export
 */
export var AnswerApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count answer by search conditions
         * @summary count answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAnswer: function (options) {
            return AnswerApiFp(configuration).countAnswer(options)(axios, basePath);
        },
        /**
         * create answer
         * @summary create answer
         * @param {ModelAnswer} body Answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswer: function (body, options) {
            return AnswerApiFp(configuration).createAnswer(body, options)(axios, basePath);
        },
        /**
         * delete answer
         * @summary delete answer
         * @param {number} id AnswerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswer: function (id, options) {
            return AnswerApiFp(configuration).deleteAnswer(id, options)(axios, basePath);
        },
        /**
         * get answer
         * @summary get answer
         * @param {number} id AnswerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswer: function (id, options) {
            return AnswerApiFp(configuration).getAnswer(id, options)(axios, basePath);
        },
        /**
         * patch answer
         * @summary patch answer
         * @param {number} id AnswerID
         * @param {ModelAnswer} body Answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAnswer: function (id, body, options) {
            return AnswerApiFp(configuration).patchAnswer(id, body, options)(axios, basePath);
        },
        /**
         * search answer by search conditions
         * @summary search answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnswer: function (options) {
            return AnswerApiFp(configuration).searchAnswer(options)(axios, basePath);
        },
        /**
         * update answer
         * @summary update answer
         * @param {number} id AnswerID
         * @param {ModelAnswer} body Answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswer: function (id, body, options) {
            return AnswerApiFp(configuration).updateAnswer(id, body, options)(axios, basePath);
        },
    };
};
/**
 * AnswerApi - object-oriented interface
 * @export
 * @class AnswerApi
 * @extends {BaseAPI}
 */
var AnswerApi = /** @class */ (function (_super) {
    __extends(AnswerApi, _super);
    function AnswerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count answer by search conditions
     * @summary count answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    AnswerApi.prototype.countAnswer = function (options) {
        return AnswerApiFp(this.configuration).countAnswer(options)(this.axios, this.basePath);
    };
    /**
     * create answer
     * @summary create answer
     * @param {ModelAnswer} body Answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    AnswerApi.prototype.createAnswer = function (body, options) {
        return AnswerApiFp(this.configuration).createAnswer(body, options)(this.axios, this.basePath);
    };
    /**
     * delete answer
     * @summary delete answer
     * @param {number} id AnswerID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    AnswerApi.prototype.deleteAnswer = function (id, options) {
        return AnswerApiFp(this.configuration).deleteAnswer(id, options)(this.axios, this.basePath);
    };
    /**
     * get answer
     * @summary get answer
     * @param {number} id AnswerID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    AnswerApi.prototype.getAnswer = function (id, options) {
        return AnswerApiFp(this.configuration).getAnswer(id, options)(this.axios, this.basePath);
    };
    /**
     * patch answer
     * @summary patch answer
     * @param {number} id AnswerID
     * @param {ModelAnswer} body Answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    AnswerApi.prototype.patchAnswer = function (id, body, options) {
        return AnswerApiFp(this.configuration).patchAnswer(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search answer by search conditions
     * @summary search answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    AnswerApi.prototype.searchAnswer = function (options) {
        return AnswerApiFp(this.configuration).searchAnswer(options)(this.axios, this.basePath);
    };
    /**
     * update answer
     * @summary update answer
     * @param {number} id AnswerID
     * @param {ModelAnswer} body Answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerApi
     */
    AnswerApi.prototype.updateAnswer = function (id, body, options) {
        return AnswerApiFp(this.configuration).updateAnswer(id, body, options)(this.axios, this.basePath);
    };
    return AnswerApi;
}(BaseAPI));
export { AnswerApi };
/**
 * AnswerInnerDataApi - axios parameter creator
 * @export
 */
export var AnswerInnerDataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count answerInnerData by search conditions
         * @summary count answerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAnswerInnerData: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/answerInnerDatas/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create answerInnerData
         * @summary create answerInnerData
         * @param {ModelAnswerInnerData} body AnswerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswerInnerData: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createAnswerInnerData.');
            }
            var localVarPath = "/answerInnerData";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete answerInnerData
         * @summary delete answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswerInnerData: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteAnswerInnerData.');
            }
            var localVarPath = "/answerInnerData/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get answerInnerData
         * @summary get answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswerInnerData: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getAnswerInnerData.');
            }
            var localVarPath = "/answerInnerData/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch answerInnerData
         * @summary patch answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {ModelAnswerInnerData} body AnswerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAnswerInnerData: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchAnswerInnerData.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchAnswerInnerData.');
            }
            var localVarPath = "/answerInnerData/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search answerInnerData by search conditions
         * @summary search answerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnswerInnerData: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/answerInnerDatas";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update answerInnerData
         * @summary update answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {ModelAnswerInnerData} body AnswerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswerInnerData: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateAnswerInnerData.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateAnswerInnerData.');
            }
            var localVarPath = "/answerInnerData/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AnswerInnerDataApi - functional programming interface
 * @export
 */
export var AnswerInnerDataApiFp = function (configuration) {
    return {
        /**
         * count answerInnerData by search conditions
         * @summary count answerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAnswerInnerData: function (options) {
            var localVarAxiosArgs = AnswerInnerDataApiAxiosParamCreator(configuration).countAnswerInnerData(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create answerInnerData
         * @summary create answerInnerData
         * @param {ModelAnswerInnerData} body AnswerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswerInnerData: function (body, options) {
            var localVarAxiosArgs = AnswerInnerDataApiAxiosParamCreator(configuration).createAnswerInnerData(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete answerInnerData
         * @summary delete answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswerInnerData: function (id, options) {
            var localVarAxiosArgs = AnswerInnerDataApiAxiosParamCreator(configuration).deleteAnswerInnerData(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get answerInnerData
         * @summary get answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswerInnerData: function (id, options) {
            var localVarAxiosArgs = AnswerInnerDataApiAxiosParamCreator(configuration).getAnswerInnerData(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch answerInnerData
         * @summary patch answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {ModelAnswerInnerData} body AnswerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAnswerInnerData: function (id, body, options) {
            var localVarAxiosArgs = AnswerInnerDataApiAxiosParamCreator(configuration).patchAnswerInnerData(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search answerInnerData by search conditions
         * @summary search answerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnswerInnerData: function (options) {
            var localVarAxiosArgs = AnswerInnerDataApiAxiosParamCreator(configuration).searchAnswerInnerData(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update answerInnerData
         * @summary update answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {ModelAnswerInnerData} body AnswerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswerInnerData: function (id, body, options) {
            var localVarAxiosArgs = AnswerInnerDataApiAxiosParamCreator(configuration).updateAnswerInnerData(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * AnswerInnerDataApi - factory interface
 * @export
 */
export var AnswerInnerDataApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count answerInnerData by search conditions
         * @summary count answerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countAnswerInnerData: function (options) {
            return AnswerInnerDataApiFp(configuration).countAnswerInnerData(options)(axios, basePath);
        },
        /**
         * create answerInnerData
         * @summary create answerInnerData
         * @param {ModelAnswerInnerData} body AnswerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnswerInnerData: function (body, options) {
            return AnswerInnerDataApiFp(configuration).createAnswerInnerData(body, options)(axios, basePath);
        },
        /**
         * delete answerInnerData
         * @summary delete answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAnswerInnerData: function (id, options) {
            return AnswerInnerDataApiFp(configuration).deleteAnswerInnerData(id, options)(axios, basePath);
        },
        /**
         * get answerInnerData
         * @summary get answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnswerInnerData: function (id, options) {
            return AnswerInnerDataApiFp(configuration).getAnswerInnerData(id, options)(axios, basePath);
        },
        /**
         * patch answerInnerData
         * @summary patch answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {ModelAnswerInnerData} body AnswerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAnswerInnerData: function (id, body, options) {
            return AnswerInnerDataApiFp(configuration).patchAnswerInnerData(id, body, options)(axios, basePath);
        },
        /**
         * search answerInnerData by search conditions
         * @summary search answerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAnswerInnerData: function (options) {
            return AnswerInnerDataApiFp(configuration).searchAnswerInnerData(options)(axios, basePath);
        },
        /**
         * update answerInnerData
         * @summary update answerInnerData
         * @param {number} id AnswerInnerDataID
         * @param {ModelAnswerInnerData} body AnswerInnerData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAnswerInnerData: function (id, body, options) {
            return AnswerInnerDataApiFp(configuration).updateAnswerInnerData(id, body, options)(axios, basePath);
        },
    };
};
/**
 * AnswerInnerDataApi - object-oriented interface
 * @export
 * @class AnswerInnerDataApi
 * @extends {BaseAPI}
 */
var AnswerInnerDataApi = /** @class */ (function (_super) {
    __extends(AnswerInnerDataApi, _super);
    function AnswerInnerDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count answerInnerData by search conditions
     * @summary count answerInnerData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerInnerDataApi
     */
    AnswerInnerDataApi.prototype.countAnswerInnerData = function (options) {
        return AnswerInnerDataApiFp(this.configuration).countAnswerInnerData(options)(this.axios, this.basePath);
    };
    /**
     * create answerInnerData
     * @summary create answerInnerData
     * @param {ModelAnswerInnerData} body AnswerInnerData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerInnerDataApi
     */
    AnswerInnerDataApi.prototype.createAnswerInnerData = function (body, options) {
        return AnswerInnerDataApiFp(this.configuration).createAnswerInnerData(body, options)(this.axios, this.basePath);
    };
    /**
     * delete answerInnerData
     * @summary delete answerInnerData
     * @param {number} id AnswerInnerDataID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerInnerDataApi
     */
    AnswerInnerDataApi.prototype.deleteAnswerInnerData = function (id, options) {
        return AnswerInnerDataApiFp(this.configuration).deleteAnswerInnerData(id, options)(this.axios, this.basePath);
    };
    /**
     * get answerInnerData
     * @summary get answerInnerData
     * @param {number} id AnswerInnerDataID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerInnerDataApi
     */
    AnswerInnerDataApi.prototype.getAnswerInnerData = function (id, options) {
        return AnswerInnerDataApiFp(this.configuration).getAnswerInnerData(id, options)(this.axios, this.basePath);
    };
    /**
     * patch answerInnerData
     * @summary patch answerInnerData
     * @param {number} id AnswerInnerDataID
     * @param {ModelAnswerInnerData} body AnswerInnerData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerInnerDataApi
     */
    AnswerInnerDataApi.prototype.patchAnswerInnerData = function (id, body, options) {
        return AnswerInnerDataApiFp(this.configuration).patchAnswerInnerData(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search answerInnerData by search conditions
     * @summary search answerInnerData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerInnerDataApi
     */
    AnswerInnerDataApi.prototype.searchAnswerInnerData = function (options) {
        return AnswerInnerDataApiFp(this.configuration).searchAnswerInnerData(options)(this.axios, this.basePath);
    };
    /**
     * update answerInnerData
     * @summary update answerInnerData
     * @param {number} id AnswerInnerDataID
     * @param {ModelAnswerInnerData} body AnswerInnerData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnswerInnerDataApi
     */
    AnswerInnerDataApi.prototype.updateAnswerInnerData = function (id, body, options) {
        return AnswerInnerDataApiFp(this.configuration).updateAnswerInnerData(id, body, options)(this.axios, this.basePath);
    };
    return AnswerInnerDataApi;
}(BaseAPI));
export { AnswerInnerDataApi };
/**
 * AppApi - axios parameter creator
 * @export
 */
export var AppApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * hello world
         * @summary hello world
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloWorld: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/hello-world";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AppApi - functional programming interface
 * @export
 */
export var AppApiFp = function (configuration) {
    return {
        /**
         * hello world
         * @summary hello world
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloWorld: function (options) {
            var localVarAxiosArgs = AppApiAxiosParamCreator(configuration).helloWorld(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * AppApi - factory interface
 * @export
 */
export var AppApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * hello world
         * @summary hello world
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloWorld: function (options) {
            return AppApiFp(configuration).helloWorld(options)(axios, basePath);
        },
    };
};
/**
 * AppApi - object-oriented interface
 * @export
 * @class AppApi
 * @extends {BaseAPI}
 */
var AppApi = /** @class */ (function (_super) {
    __extends(AppApi, _super);
    function AppApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * hello world
     * @summary hello world
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    AppApi.prototype.helloWorld = function (options) {
        return AppApiFp(this.configuration).helloWorld(options)(this.axios, this.basePath);
    };
    return AppApi;
}(BaseAPI));
export { AppApi };
/**
 * EntryApi - axios parameter creator
 * @export
 */
export var EntryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count entry by search conditions
         * @summary count entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEntry: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/entrys/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create entry
         * @summary create entry
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntry: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createEntry.');
            }
            var localVarPath = "/entry";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete entry
         * @summary delete entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntry: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteEntry.');
            }
            var localVarPath = "/entry/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get entry
         * @summary get entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntry: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getEntry.');
            }
            var localVarPath = "/entry/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch entry
         * @summary patch entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntry: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchEntry.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchEntry.');
            }
            var localVarPath = "/entry/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search entry by search conditions
         * @summary search entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntry: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/entrys";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * send mail result
         * @summary send mail result
         * @param {number} id EntryID
         * @param {HandlerSendMailRequest} body Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMail: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling sendMail.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling sendMail.');
            }
            var localVarPath = "/entry/{id}/sendMail"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update entry
         * @summary update entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntry: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateEntry.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateEntry.');
            }
            var localVarPath = "/entry/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EntryApi - functional programming interface
 * @export
 */
export var EntryApiFp = function (configuration) {
    return {
        /**
         * count entry by search conditions
         * @summary count entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEntry: function (options) {
            var localVarAxiosArgs = EntryApiAxiosParamCreator(configuration).countEntry(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create entry
         * @summary create entry
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntry: function (body, options) {
            var localVarAxiosArgs = EntryApiAxiosParamCreator(configuration).createEntry(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete entry
         * @summary delete entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntry: function (id, options) {
            var localVarAxiosArgs = EntryApiAxiosParamCreator(configuration).deleteEntry(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get entry
         * @summary get entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntry: function (id, options) {
            var localVarAxiosArgs = EntryApiAxiosParamCreator(configuration).getEntry(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch entry
         * @summary patch entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntry: function (id, body, options) {
            var localVarAxiosArgs = EntryApiAxiosParamCreator(configuration).patchEntry(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search entry by search conditions
         * @summary search entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntry: function (options) {
            var localVarAxiosArgs = EntryApiAxiosParamCreator(configuration).searchEntry(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * send mail result
         * @summary send mail result
         * @param {number} id EntryID
         * @param {HandlerSendMailRequest} body Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMail: function (id, body, options) {
            var localVarAxiosArgs = EntryApiAxiosParamCreator(configuration).sendMail(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update entry
         * @summary update entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntry: function (id, body, options) {
            var localVarAxiosArgs = EntryApiAxiosParamCreator(configuration).updateEntry(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * EntryApi - factory interface
 * @export
 */
export var EntryApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count entry by search conditions
         * @summary count entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEntry: function (options) {
            return EntryApiFp(configuration).countEntry(options)(axios, basePath);
        },
        /**
         * create entry
         * @summary create entry
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntry: function (body, options) {
            return EntryApiFp(configuration).createEntry(body, options)(axios, basePath);
        },
        /**
         * delete entry
         * @summary delete entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntry: function (id, options) {
            return EntryApiFp(configuration).deleteEntry(id, options)(axios, basePath);
        },
        /**
         * get entry
         * @summary get entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntry: function (id, options) {
            return EntryApiFp(configuration).getEntry(id, options)(axios, basePath);
        },
        /**
         * patch entry
         * @summary patch entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntry: function (id, body, options) {
            return EntryApiFp(configuration).patchEntry(id, body, options)(axios, basePath);
        },
        /**
         * search entry by search conditions
         * @summary search entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntry: function (options) {
            return EntryApiFp(configuration).searchEntry(options)(axios, basePath);
        },
        /**
         * send mail result
         * @summary send mail result
         * @param {number} id EntryID
         * @param {HandlerSendMailRequest} body Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMail: function (id, body, options) {
            return EntryApiFp(configuration).sendMail(id, body, options)(axios, basePath);
        },
        /**
         * update entry
         * @summary update entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntry: function (id, body, options) {
            return EntryApiFp(configuration).updateEntry(id, body, options)(axios, basePath);
        },
    };
};
/**
 * EntryApi - object-oriented interface
 * @export
 * @class EntryApi
 * @extends {BaseAPI}
 */
var EntryApi = /** @class */ (function (_super) {
    __extends(EntryApi, _super);
    function EntryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count entry by search conditions
     * @summary count entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.countEntry = function (options) {
        return EntryApiFp(this.configuration).countEntry(options)(this.axios, this.basePath);
    };
    /**
     * create entry
     * @summary create entry
     * @param {ModelEntry} body Entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.createEntry = function (body, options) {
        return EntryApiFp(this.configuration).createEntry(body, options)(this.axios, this.basePath);
    };
    /**
     * delete entry
     * @summary delete entry
     * @param {number} id EntryID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.deleteEntry = function (id, options) {
        return EntryApiFp(this.configuration).deleteEntry(id, options)(this.axios, this.basePath);
    };
    /**
     * get entry
     * @summary get entry
     * @param {number} id EntryID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.getEntry = function (id, options) {
        return EntryApiFp(this.configuration).getEntry(id, options)(this.axios, this.basePath);
    };
    /**
     * patch entry
     * @summary patch entry
     * @param {number} id EntryID
     * @param {ModelEntry} body Entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.patchEntry = function (id, body, options) {
        return EntryApiFp(this.configuration).patchEntry(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search entry by search conditions
     * @summary search entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.searchEntry = function (options) {
        return EntryApiFp(this.configuration).searchEntry(options)(this.axios, this.basePath);
    };
    /**
     * send mail result
     * @summary send mail result
     * @param {number} id EntryID
     * @param {HandlerSendMailRequest} body Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.sendMail = function (id, body, options) {
        return EntryApiFp(this.configuration).sendMail(id, body, options)(this.axios, this.basePath);
    };
    /**
     * update entry
     * @summary update entry
     * @param {number} id EntryID
     * @param {ModelEntry} body Entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.updateEntry = function (id, body, options) {
        return EntryApiFp(this.configuration).updateEntry(id, body, options)(this.axios, this.basePath);
    };
    return EntryApi;
}(BaseAPI));
export { EntryApi };
/**
 * ImageApi - axios parameter creator
 * @export
 */
export var ImageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * upload image
         * @summary upload image
         * @param {string} name image name
         * @param {string} dir save directory
         * @param {boolean} thumbnail make thumbnail
         * @param {any} image raw image
         * @param {number} [resize] resize size
         * @param {number} [thumbnailSize] thumbnail size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: function (name, dir, thumbnail, image, resize, thumbnailSize, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name', 'Required parameter name was null or undefined when calling uploadImage.');
            }
            // verify required parameter 'dir' is not null or undefined
            if (dir === null || dir === undefined) {
                throw new RequiredError('dir', 'Required parameter dir was null or undefined when calling uploadImage.');
            }
            // verify required parameter 'thumbnail' is not null or undefined
            if (thumbnail === null || thumbnail === undefined) {
                throw new RequiredError('thumbnail', 'Required parameter thumbnail was null or undefined when calling uploadImage.');
            }
            // verify required parameter 'image' is not null or undefined
            if (image === null || image === undefined) {
                throw new RequiredError('image', 'Required parameter image was null or undefined when calling uploadImage.');
            }
            var localVarPath = "/image";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new FormData();
            if (name !== undefined) {
                localVarFormParams.append('name', name);
            }
            if (dir !== undefined) {
                localVarFormParams.append('dir', dir);
            }
            if (resize !== undefined) {
                localVarFormParams.append('resize', resize);
            }
            if (thumbnail !== undefined) {
                localVarFormParams.append('thumbnail', thumbnail);
            }
            if (thumbnailSize !== undefined) {
                localVarFormParams.append('thumbnailSize', thumbnailSize);
            }
            if (image !== undefined) {
                localVarFormParams.append('image', image);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ImageApi - functional programming interface
 * @export
 */
export var ImageApiFp = function (configuration) {
    return {
        /**
         * upload image
         * @summary upload image
         * @param {string} name image name
         * @param {string} dir save directory
         * @param {boolean} thumbnail make thumbnail
         * @param {any} image raw image
         * @param {number} [resize] resize size
         * @param {number} [thumbnailSize] thumbnail size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: function (name, dir, thumbnail, image, resize, thumbnailSize, options) {
            var localVarAxiosArgs = ImageApiAxiosParamCreator(configuration).uploadImage(name, dir, thumbnail, image, resize, thumbnailSize, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ImageApi - factory interface
 * @export
 */
export var ImageApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * upload image
         * @summary upload image
         * @param {string} name image name
         * @param {string} dir save directory
         * @param {boolean} thumbnail make thumbnail
         * @param {any} image raw image
         * @param {number} [resize] resize size
         * @param {number} [thumbnailSize] thumbnail size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: function (name, dir, thumbnail, image, resize, thumbnailSize, options) {
            return ImageApiFp(configuration).uploadImage(name, dir, thumbnail, image, resize, thumbnailSize, options)(axios, basePath);
        },
    };
};
/**
 * ImageApi - object-oriented interface
 * @export
 * @class ImageApi
 * @extends {BaseAPI}
 */
var ImageApi = /** @class */ (function (_super) {
    __extends(ImageApi, _super);
    function ImageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * upload image
     * @summary upload image
     * @param {string} name image name
     * @param {string} dir save directory
     * @param {boolean} thumbnail make thumbnail
     * @param {any} image raw image
     * @param {number} [resize] resize size
     * @param {number} [thumbnailSize] thumbnail size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    ImageApi.prototype.uploadImage = function (name, dir, thumbnail, image, resize, thumbnailSize, options) {
        return ImageApiFp(this.configuration).uploadImage(name, dir, thumbnail, image, resize, thumbnailSize, options)(this.axios, this.basePath);
    };
    return ImageApi;
}(BaseAPI));
export { ImageApi };
/**
 * QuestionCandidateApi - axios parameter creator
 * @export
 */
export var QuestionCandidateApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count questionCandidate by search conditions
         * @summary count questionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countQuestionCandidate: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/questionCandidates/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create questionCandidate
         * @summary create questionCandidate
         * @param {ModelQuestionCandidate} body QuestionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionCandidate: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createQuestionCandidate.');
            }
            var localVarPath = "/questionCandidate";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete questionCandidate
         * @summary delete questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestionCandidate: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteQuestionCandidate.');
            }
            var localVarPath = "/questionCandidate/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get questionCandidate
         * @summary get questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCandidate: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getQuestionCandidate.');
            }
            var localVarPath = "/questionCandidate/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch questionCandidate
         * @summary patch questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {ModelQuestionCandidate} body QuestionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchQuestionCandidate: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchQuestionCandidate.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchQuestionCandidate.');
            }
            var localVarPath = "/questionCandidate/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search questionCandidate by search conditions
         * @summary search questionCandidate
         * @param {string} [surveyID] surveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchQuestionCandidate: function (surveyID, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/questionCandidates";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (surveyID !== undefined) {
                localVarQueryParameter['surveyID'] = surveyID;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update questionCandidate
         * @summary update questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {ModelQuestionCandidate} body QuestionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionCandidate: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateQuestionCandidate.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateQuestionCandidate.');
            }
            var localVarPath = "/questionCandidate/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * QuestionCandidateApi - functional programming interface
 * @export
 */
export var QuestionCandidateApiFp = function (configuration) {
    return {
        /**
         * count questionCandidate by search conditions
         * @summary count questionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countQuestionCandidate: function (options) {
            var localVarAxiosArgs = QuestionCandidateApiAxiosParamCreator(configuration).countQuestionCandidate(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create questionCandidate
         * @summary create questionCandidate
         * @param {ModelQuestionCandidate} body QuestionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionCandidate: function (body, options) {
            var localVarAxiosArgs = QuestionCandidateApiAxiosParamCreator(configuration).createQuestionCandidate(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete questionCandidate
         * @summary delete questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestionCandidate: function (id, options) {
            var localVarAxiosArgs = QuestionCandidateApiAxiosParamCreator(configuration).deleteQuestionCandidate(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get questionCandidate
         * @summary get questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCandidate: function (id, options) {
            var localVarAxiosArgs = QuestionCandidateApiAxiosParamCreator(configuration).getQuestionCandidate(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch questionCandidate
         * @summary patch questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {ModelQuestionCandidate} body QuestionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchQuestionCandidate: function (id, body, options) {
            var localVarAxiosArgs = QuestionCandidateApiAxiosParamCreator(configuration).patchQuestionCandidate(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search questionCandidate by search conditions
         * @summary search questionCandidate
         * @param {string} [surveyID] surveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchQuestionCandidate: function (surveyID, options) {
            var localVarAxiosArgs = QuestionCandidateApiAxiosParamCreator(configuration).searchQuestionCandidate(surveyID, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update questionCandidate
         * @summary update questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {ModelQuestionCandidate} body QuestionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionCandidate: function (id, body, options) {
            var localVarAxiosArgs = QuestionCandidateApiAxiosParamCreator(configuration).updateQuestionCandidate(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * QuestionCandidateApi - factory interface
 * @export
 */
export var QuestionCandidateApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count questionCandidate by search conditions
         * @summary count questionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countQuestionCandidate: function (options) {
            return QuestionCandidateApiFp(configuration).countQuestionCandidate(options)(axios, basePath);
        },
        /**
         * create questionCandidate
         * @summary create questionCandidate
         * @param {ModelQuestionCandidate} body QuestionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionCandidate: function (body, options) {
            return QuestionCandidateApiFp(configuration).createQuestionCandidate(body, options)(axios, basePath);
        },
        /**
         * delete questionCandidate
         * @summary delete questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestionCandidate: function (id, options) {
            return QuestionCandidateApiFp(configuration).deleteQuestionCandidate(id, options)(axios, basePath);
        },
        /**
         * get questionCandidate
         * @summary get questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCandidate: function (id, options) {
            return QuestionCandidateApiFp(configuration).getQuestionCandidate(id, options)(axios, basePath);
        },
        /**
         * patch questionCandidate
         * @summary patch questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {ModelQuestionCandidate} body QuestionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchQuestionCandidate: function (id, body, options) {
            return QuestionCandidateApiFp(configuration).patchQuestionCandidate(id, body, options)(axios, basePath);
        },
        /**
         * search questionCandidate by search conditions
         * @summary search questionCandidate
         * @param {string} [surveyID] surveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchQuestionCandidate: function (surveyID, options) {
            return QuestionCandidateApiFp(configuration).searchQuestionCandidate(surveyID, options)(axios, basePath);
        },
        /**
         * update questionCandidate
         * @summary update questionCandidate
         * @param {number} id QuestionCandidateID
         * @param {ModelQuestionCandidate} body QuestionCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionCandidate: function (id, body, options) {
            return QuestionCandidateApiFp(configuration).updateQuestionCandidate(id, body, options)(axios, basePath);
        },
    };
};
/**
 * QuestionCandidateApi - object-oriented interface
 * @export
 * @class QuestionCandidateApi
 * @extends {BaseAPI}
 */
var QuestionCandidateApi = /** @class */ (function (_super) {
    __extends(QuestionCandidateApi, _super);
    function QuestionCandidateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count questionCandidate by search conditions
     * @summary count questionCandidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionCandidateApi
     */
    QuestionCandidateApi.prototype.countQuestionCandidate = function (options) {
        return QuestionCandidateApiFp(this.configuration).countQuestionCandidate(options)(this.axios, this.basePath);
    };
    /**
     * create questionCandidate
     * @summary create questionCandidate
     * @param {ModelQuestionCandidate} body QuestionCandidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionCandidateApi
     */
    QuestionCandidateApi.prototype.createQuestionCandidate = function (body, options) {
        return QuestionCandidateApiFp(this.configuration).createQuestionCandidate(body, options)(this.axios, this.basePath);
    };
    /**
     * delete questionCandidate
     * @summary delete questionCandidate
     * @param {number} id QuestionCandidateID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionCandidateApi
     */
    QuestionCandidateApi.prototype.deleteQuestionCandidate = function (id, options) {
        return QuestionCandidateApiFp(this.configuration).deleteQuestionCandidate(id, options)(this.axios, this.basePath);
    };
    /**
     * get questionCandidate
     * @summary get questionCandidate
     * @param {number} id QuestionCandidateID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionCandidateApi
     */
    QuestionCandidateApi.prototype.getQuestionCandidate = function (id, options) {
        return QuestionCandidateApiFp(this.configuration).getQuestionCandidate(id, options)(this.axios, this.basePath);
    };
    /**
     * patch questionCandidate
     * @summary patch questionCandidate
     * @param {number} id QuestionCandidateID
     * @param {ModelQuestionCandidate} body QuestionCandidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionCandidateApi
     */
    QuestionCandidateApi.prototype.patchQuestionCandidate = function (id, body, options) {
        return QuestionCandidateApiFp(this.configuration).patchQuestionCandidate(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search questionCandidate by search conditions
     * @summary search questionCandidate
     * @param {string} [surveyID] surveyID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionCandidateApi
     */
    QuestionCandidateApi.prototype.searchQuestionCandidate = function (surveyID, options) {
        return QuestionCandidateApiFp(this.configuration).searchQuestionCandidate(surveyID, options)(this.axios, this.basePath);
    };
    /**
     * update questionCandidate
     * @summary update questionCandidate
     * @param {number} id QuestionCandidateID
     * @param {ModelQuestionCandidate} body QuestionCandidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionCandidateApi
     */
    QuestionCandidateApi.prototype.updateQuestionCandidate = function (id, body, options) {
        return QuestionCandidateApiFp(this.configuration).updateQuestionCandidate(id, body, options)(this.axios, this.basePath);
    };
    return QuestionCandidateApi;
}(BaseAPI));
export { QuestionCandidateApi };
/**
 * ResultApi - axios parameter creator
 * @export
 */
export var ResultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count result by search conditions
         * @summary count result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countResult: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/results/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create result
         * @summary create result
         * @param {ModelResult} body Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResult: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createResult.');
            }
            var localVarPath = "/result";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete result
         * @summary delete result
         * @param {number} id ResultID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResult: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteResult.');
            }
            var localVarPath = "/result/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get result
         * @summary get result
         * @param {number} id ResultID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResult: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getResult.');
            }
            var localVarPath = "/result/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch result
         * @summary patch result
         * @param {number} id ResultID
         * @param {ModelResult} body Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResult: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchResult.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchResult.');
            }
            var localVarPath = "/result/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search result by search conditions
         * @summary search result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResult: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/results";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update result
         * @summary update result
         * @param {number} id ResultID
         * @param {ModelResult} body Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResult: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateResult.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateResult.');
            }
            var localVarPath = "/result/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ResultApi - functional programming interface
 * @export
 */
export var ResultApiFp = function (configuration) {
    return {
        /**
         * count result by search conditions
         * @summary count result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countResult: function (options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).countResult(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create result
         * @summary create result
         * @param {ModelResult} body Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResult: function (body, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).createResult(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete result
         * @summary delete result
         * @param {number} id ResultID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResult: function (id, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).deleteResult(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get result
         * @summary get result
         * @param {number} id ResultID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResult: function (id, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).getResult(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch result
         * @summary patch result
         * @param {number} id ResultID
         * @param {ModelResult} body Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResult: function (id, body, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).patchResult(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search result by search conditions
         * @summary search result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResult: function (options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).searchResult(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update result
         * @summary update result
         * @param {number} id ResultID
         * @param {ModelResult} body Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResult: function (id, body, options) {
            var localVarAxiosArgs = ResultApiAxiosParamCreator(configuration).updateResult(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ResultApi - factory interface
 * @export
 */
export var ResultApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count result by search conditions
         * @summary count result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countResult: function (options) {
            return ResultApiFp(configuration).countResult(options)(axios, basePath);
        },
        /**
         * create result
         * @summary create result
         * @param {ModelResult} body Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResult: function (body, options) {
            return ResultApiFp(configuration).createResult(body, options)(axios, basePath);
        },
        /**
         * delete result
         * @summary delete result
         * @param {number} id ResultID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResult: function (id, options) {
            return ResultApiFp(configuration).deleteResult(id, options)(axios, basePath);
        },
        /**
         * get result
         * @summary get result
         * @param {number} id ResultID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResult: function (id, options) {
            return ResultApiFp(configuration).getResult(id, options)(axios, basePath);
        },
        /**
         * patch result
         * @summary patch result
         * @param {number} id ResultID
         * @param {ModelResult} body Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResult: function (id, body, options) {
            return ResultApiFp(configuration).patchResult(id, body, options)(axios, basePath);
        },
        /**
         * search result by search conditions
         * @summary search result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResult: function (options) {
            return ResultApiFp(configuration).searchResult(options)(axios, basePath);
        },
        /**
         * update result
         * @summary update result
         * @param {number} id ResultID
         * @param {ModelResult} body Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResult: function (id, body, options) {
            return ResultApiFp(configuration).updateResult(id, body, options)(axios, basePath);
        },
    };
};
/**
 * ResultApi - object-oriented interface
 * @export
 * @class ResultApi
 * @extends {BaseAPI}
 */
var ResultApi = /** @class */ (function (_super) {
    __extends(ResultApi, _super);
    function ResultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count result by search conditions
     * @summary count result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.countResult = function (options) {
        return ResultApiFp(this.configuration).countResult(options)(this.axios, this.basePath);
    };
    /**
     * create result
     * @summary create result
     * @param {ModelResult} body Result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.createResult = function (body, options) {
        return ResultApiFp(this.configuration).createResult(body, options)(this.axios, this.basePath);
    };
    /**
     * delete result
     * @summary delete result
     * @param {number} id ResultID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.deleteResult = function (id, options) {
        return ResultApiFp(this.configuration).deleteResult(id, options)(this.axios, this.basePath);
    };
    /**
     * get result
     * @summary get result
     * @param {number} id ResultID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.getResult = function (id, options) {
        return ResultApiFp(this.configuration).getResult(id, options)(this.axios, this.basePath);
    };
    /**
     * patch result
     * @summary patch result
     * @param {number} id ResultID
     * @param {ModelResult} body Result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.patchResult = function (id, body, options) {
        return ResultApiFp(this.configuration).patchResult(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search result by search conditions
     * @summary search result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.searchResult = function (options) {
        return ResultApiFp(this.configuration).searchResult(options)(this.axios, this.basePath);
    };
    /**
     * update result
     * @summary update result
     * @param {number} id ResultID
     * @param {ModelResult} body Result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultApi
     */
    ResultApi.prototype.updateResult = function (id, body, options) {
        return ResultApiFp(this.configuration).updateResult(id, body, options)(this.axios, this.basePath);
    };
    return ResultApi;
}(BaseAPI));
export { ResultApi };
/**
 * ResultCandidateApi - axios parameter creator
 * @export
 */
export var ResultCandidateApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count resultCandidate by search conditions
         * @summary count resultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countResultCandidate: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/resultCandidates/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create resultCandidate
         * @summary create resultCandidate
         * @param {ModelResultCandidate} body ResultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResultCandidate: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createResultCandidate.');
            }
            var localVarPath = "/resultCandidate";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete resultCandidate
         * @summary delete resultCandidate
         * @param {number} id ResultCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResultCandidate: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteResultCandidate.');
            }
            var localVarPath = "/resultCandidate/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get resultCandidate
         * @summary get resultCandidate
         * @param {number} id ResultCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResultCandidate: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getResultCandidate.');
            }
            var localVarPath = "/resultCandidate/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch resultCandidate
         * @summary patch resultCandidate
         * @param {number} id ResultCandidateID
         * @param {ModelResultCandidate} body ResultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResultCandidate: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchResultCandidate.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchResultCandidate.');
            }
            var localVarPath = "/resultCandidate/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search resultCandidate by search conditions
         * @summary search resultCandidate
         * @param {string} [surveyID] surveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResultCandidate: function (surveyID, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/resultCandidates";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (surveyID !== undefined) {
                localVarQueryParameter['surveyID'] = surveyID;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update resultCandidate
         * @summary update resultCandidate
         * @param {number} id ResultCandidateID
         * @param {ModelResultCandidate} body ResultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResultCandidate: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateResultCandidate.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateResultCandidate.');
            }
            var localVarPath = "/resultCandidate/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ResultCandidateApi - functional programming interface
 * @export
 */
export var ResultCandidateApiFp = function (configuration) {
    return {
        /**
         * count resultCandidate by search conditions
         * @summary count resultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countResultCandidate: function (options) {
            var localVarAxiosArgs = ResultCandidateApiAxiosParamCreator(configuration).countResultCandidate(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create resultCandidate
         * @summary create resultCandidate
         * @param {ModelResultCandidate} body ResultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResultCandidate: function (body, options) {
            var localVarAxiosArgs = ResultCandidateApiAxiosParamCreator(configuration).createResultCandidate(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete resultCandidate
         * @summary delete resultCandidate
         * @param {number} id ResultCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResultCandidate: function (id, options) {
            var localVarAxiosArgs = ResultCandidateApiAxiosParamCreator(configuration).deleteResultCandidate(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get resultCandidate
         * @summary get resultCandidate
         * @param {number} id ResultCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResultCandidate: function (id, options) {
            var localVarAxiosArgs = ResultCandidateApiAxiosParamCreator(configuration).getResultCandidate(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch resultCandidate
         * @summary patch resultCandidate
         * @param {number} id ResultCandidateID
         * @param {ModelResultCandidate} body ResultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResultCandidate: function (id, body, options) {
            var localVarAxiosArgs = ResultCandidateApiAxiosParamCreator(configuration).patchResultCandidate(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search resultCandidate by search conditions
         * @summary search resultCandidate
         * @param {string} [surveyID] surveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResultCandidate: function (surveyID, options) {
            var localVarAxiosArgs = ResultCandidateApiAxiosParamCreator(configuration).searchResultCandidate(surveyID, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update resultCandidate
         * @summary update resultCandidate
         * @param {number} id ResultCandidateID
         * @param {ModelResultCandidate} body ResultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResultCandidate: function (id, body, options) {
            var localVarAxiosArgs = ResultCandidateApiAxiosParamCreator(configuration).updateResultCandidate(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ResultCandidateApi - factory interface
 * @export
 */
export var ResultCandidateApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count resultCandidate by search conditions
         * @summary count resultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countResultCandidate: function (options) {
            return ResultCandidateApiFp(configuration).countResultCandidate(options)(axios, basePath);
        },
        /**
         * create resultCandidate
         * @summary create resultCandidate
         * @param {ModelResultCandidate} body ResultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResultCandidate: function (body, options) {
            return ResultCandidateApiFp(configuration).createResultCandidate(body, options)(axios, basePath);
        },
        /**
         * delete resultCandidate
         * @summary delete resultCandidate
         * @param {number} id ResultCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResultCandidate: function (id, options) {
            return ResultCandidateApiFp(configuration).deleteResultCandidate(id, options)(axios, basePath);
        },
        /**
         * get resultCandidate
         * @summary get resultCandidate
         * @param {number} id ResultCandidateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResultCandidate: function (id, options) {
            return ResultCandidateApiFp(configuration).getResultCandidate(id, options)(axios, basePath);
        },
        /**
         * patch resultCandidate
         * @summary patch resultCandidate
         * @param {number} id ResultCandidateID
         * @param {ModelResultCandidate} body ResultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResultCandidate: function (id, body, options) {
            return ResultCandidateApiFp(configuration).patchResultCandidate(id, body, options)(axios, basePath);
        },
        /**
         * search resultCandidate by search conditions
         * @summary search resultCandidate
         * @param {string} [surveyID] surveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResultCandidate: function (surveyID, options) {
            return ResultCandidateApiFp(configuration).searchResultCandidate(surveyID, options)(axios, basePath);
        },
        /**
         * update resultCandidate
         * @summary update resultCandidate
         * @param {number} id ResultCandidateID
         * @param {ModelResultCandidate} body ResultCandidate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResultCandidate: function (id, body, options) {
            return ResultCandidateApiFp(configuration).updateResultCandidate(id, body, options)(axios, basePath);
        },
    };
};
/**
 * ResultCandidateApi - object-oriented interface
 * @export
 * @class ResultCandidateApi
 * @extends {BaseAPI}
 */
var ResultCandidateApi = /** @class */ (function (_super) {
    __extends(ResultCandidateApi, _super);
    function ResultCandidateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count resultCandidate by search conditions
     * @summary count resultCandidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultCandidateApi
     */
    ResultCandidateApi.prototype.countResultCandidate = function (options) {
        return ResultCandidateApiFp(this.configuration).countResultCandidate(options)(this.axios, this.basePath);
    };
    /**
     * create resultCandidate
     * @summary create resultCandidate
     * @param {ModelResultCandidate} body ResultCandidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultCandidateApi
     */
    ResultCandidateApi.prototype.createResultCandidate = function (body, options) {
        return ResultCandidateApiFp(this.configuration).createResultCandidate(body, options)(this.axios, this.basePath);
    };
    /**
     * delete resultCandidate
     * @summary delete resultCandidate
     * @param {number} id ResultCandidateID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultCandidateApi
     */
    ResultCandidateApi.prototype.deleteResultCandidate = function (id, options) {
        return ResultCandidateApiFp(this.configuration).deleteResultCandidate(id, options)(this.axios, this.basePath);
    };
    /**
     * get resultCandidate
     * @summary get resultCandidate
     * @param {number} id ResultCandidateID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultCandidateApi
     */
    ResultCandidateApi.prototype.getResultCandidate = function (id, options) {
        return ResultCandidateApiFp(this.configuration).getResultCandidate(id, options)(this.axios, this.basePath);
    };
    /**
     * patch resultCandidate
     * @summary patch resultCandidate
     * @param {number} id ResultCandidateID
     * @param {ModelResultCandidate} body ResultCandidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultCandidateApi
     */
    ResultCandidateApi.prototype.patchResultCandidate = function (id, body, options) {
        return ResultCandidateApiFp(this.configuration).patchResultCandidate(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search resultCandidate by search conditions
     * @summary search resultCandidate
     * @param {string} [surveyID] surveyID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultCandidateApi
     */
    ResultCandidateApi.prototype.searchResultCandidate = function (surveyID, options) {
        return ResultCandidateApiFp(this.configuration).searchResultCandidate(surveyID, options)(this.axios, this.basePath);
    };
    /**
     * update resultCandidate
     * @summary update resultCandidate
     * @param {number} id ResultCandidateID
     * @param {ModelResultCandidate} body ResultCandidate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResultCandidateApi
     */
    ResultCandidateApi.prototype.updateResultCandidate = function (id, body, options) {
        return ResultCandidateApiFp(this.configuration).updateResultCandidate(id, body, options)(this.axios, this.basePath);
    };
    return ResultCandidateApi;
}(BaseAPI));
export { ResultCandidateApi };
/**
 * ScenarioApi - axios parameter creator
 * @export
 */
export var ScenarioApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count scenario by search conditions
         * @summary count scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countScenario: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/scenarios/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create scenario
         * @summary create scenario
         * @param {ModelScenario} body Scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScenario: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createScenario.');
            }
            var localVarPath = "/scenario";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete scenario
         * @summary delete scenario
         * @param {number} id ScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScenario: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteScenario.');
            }
            var localVarPath = "/scenario/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get scenario
         * @summary get scenario
         * @param {number} id ScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenario: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getScenario.');
            }
            var localVarPath = "/scenario/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch scenario
         * @summary patch scenario
         * @param {number} id ScenarioID
         * @param {ModelScenario} body Scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchScenario: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchScenario.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchScenario.');
            }
            var localVarPath = "/scenario/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search scenario by search conditions
         * @summary search scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchScenario: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/scenarios";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update scenario
         * @summary update scenario
         * @param {number} id ScenarioID
         * @param {ModelScenario} body Scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScenario: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateScenario.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateScenario.');
            }
            var localVarPath = "/scenario/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ScenarioApi - functional programming interface
 * @export
 */
export var ScenarioApiFp = function (configuration) {
    return {
        /**
         * count scenario by search conditions
         * @summary count scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countScenario: function (options) {
            var localVarAxiosArgs = ScenarioApiAxiosParamCreator(configuration).countScenario(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create scenario
         * @summary create scenario
         * @param {ModelScenario} body Scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScenario: function (body, options) {
            var localVarAxiosArgs = ScenarioApiAxiosParamCreator(configuration).createScenario(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete scenario
         * @summary delete scenario
         * @param {number} id ScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScenario: function (id, options) {
            var localVarAxiosArgs = ScenarioApiAxiosParamCreator(configuration).deleteScenario(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get scenario
         * @summary get scenario
         * @param {number} id ScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenario: function (id, options) {
            var localVarAxiosArgs = ScenarioApiAxiosParamCreator(configuration).getScenario(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch scenario
         * @summary patch scenario
         * @param {number} id ScenarioID
         * @param {ModelScenario} body Scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchScenario: function (id, body, options) {
            var localVarAxiosArgs = ScenarioApiAxiosParamCreator(configuration).patchScenario(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search scenario by search conditions
         * @summary search scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchScenario: function (options) {
            var localVarAxiosArgs = ScenarioApiAxiosParamCreator(configuration).searchScenario(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update scenario
         * @summary update scenario
         * @param {number} id ScenarioID
         * @param {ModelScenario} body Scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScenario: function (id, body, options) {
            var localVarAxiosArgs = ScenarioApiAxiosParamCreator(configuration).updateScenario(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ScenarioApi - factory interface
 * @export
 */
export var ScenarioApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count scenario by search conditions
         * @summary count scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countScenario: function (options) {
            return ScenarioApiFp(configuration).countScenario(options)(axios, basePath);
        },
        /**
         * create scenario
         * @summary create scenario
         * @param {ModelScenario} body Scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScenario: function (body, options) {
            return ScenarioApiFp(configuration).createScenario(body, options)(axios, basePath);
        },
        /**
         * delete scenario
         * @summary delete scenario
         * @param {number} id ScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScenario: function (id, options) {
            return ScenarioApiFp(configuration).deleteScenario(id, options)(axios, basePath);
        },
        /**
         * get scenario
         * @summary get scenario
         * @param {number} id ScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenario: function (id, options) {
            return ScenarioApiFp(configuration).getScenario(id, options)(axios, basePath);
        },
        /**
         * patch scenario
         * @summary patch scenario
         * @param {number} id ScenarioID
         * @param {ModelScenario} body Scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchScenario: function (id, body, options) {
            return ScenarioApiFp(configuration).patchScenario(id, body, options)(axios, basePath);
        },
        /**
         * search scenario by search conditions
         * @summary search scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchScenario: function (options) {
            return ScenarioApiFp(configuration).searchScenario(options)(axios, basePath);
        },
        /**
         * update scenario
         * @summary update scenario
         * @param {number} id ScenarioID
         * @param {ModelScenario} body Scenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScenario: function (id, body, options) {
            return ScenarioApiFp(configuration).updateScenario(id, body, options)(axios, basePath);
        },
    };
};
/**
 * ScenarioApi - object-oriented interface
 * @export
 * @class ScenarioApi
 * @extends {BaseAPI}
 */
var ScenarioApi = /** @class */ (function (_super) {
    __extends(ScenarioApi, _super);
    function ScenarioApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count scenario by search conditions
     * @summary count scenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioApi
     */
    ScenarioApi.prototype.countScenario = function (options) {
        return ScenarioApiFp(this.configuration).countScenario(options)(this.axios, this.basePath);
    };
    /**
     * create scenario
     * @summary create scenario
     * @param {ModelScenario} body Scenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioApi
     */
    ScenarioApi.prototype.createScenario = function (body, options) {
        return ScenarioApiFp(this.configuration).createScenario(body, options)(this.axios, this.basePath);
    };
    /**
     * delete scenario
     * @summary delete scenario
     * @param {number} id ScenarioID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioApi
     */
    ScenarioApi.prototype.deleteScenario = function (id, options) {
        return ScenarioApiFp(this.configuration).deleteScenario(id, options)(this.axios, this.basePath);
    };
    /**
     * get scenario
     * @summary get scenario
     * @param {number} id ScenarioID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioApi
     */
    ScenarioApi.prototype.getScenario = function (id, options) {
        return ScenarioApiFp(this.configuration).getScenario(id, options)(this.axios, this.basePath);
    };
    /**
     * patch scenario
     * @summary patch scenario
     * @param {number} id ScenarioID
     * @param {ModelScenario} body Scenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioApi
     */
    ScenarioApi.prototype.patchScenario = function (id, body, options) {
        return ScenarioApiFp(this.configuration).patchScenario(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search scenario by search conditions
     * @summary search scenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioApi
     */
    ScenarioApi.prototype.searchScenario = function (options) {
        return ScenarioApiFp(this.configuration).searchScenario(options)(this.axios, this.basePath);
    };
    /**
     * update scenario
     * @summary update scenario
     * @param {number} id ScenarioID
     * @param {ModelScenario} body Scenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScenarioApi
     */
    ScenarioApi.prototype.updateScenario = function (id, body, options) {
        return ScenarioApiFp(this.configuration).updateScenario(id, body, options)(this.axios, this.basePath);
    };
    return ScenarioApi;
}(BaseAPI));
export { ScenarioApi };
/**
 * SurveyApi - axios parameter creator
 * @export
 */
export var SurveyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count survey by search conditions
         * @summary count survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSurvey: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/surveys/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create survey
         * @summary create survey
         * @param {ModelSurvey} body Survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createSurvey.');
            }
            var localVarPath = "/survey";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete survey
         * @summary delete survey
         * @param {number} id SurveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteSurvey.');
            }
            var localVarPath = "/survey/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get survey
         * @summary get survey
         * @param {number} id SurveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getSurvey.');
            }
            var localVarPath = "/survey/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch survey
         * @summary patch survey
         * @param {number} id SurveyID
         * @param {ModelSurvey} body Survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSurvey: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchSurvey.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchSurvey.');
            }
            var localVarPath = "/survey/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search survey by search conditions
         * @summary search survey
         * @param {string} [tenantID] tenantID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSurvey: function (tenantID, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/surveys";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (tenantID !== undefined) {
                localVarQueryParameter['tenantID'] = tenantID;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update survey
         * @summary update survey
         * @param {number} id SurveyID
         * @param {ModelSurvey} body Survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateSurvey.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateSurvey.');
            }
            var localVarPath = "/survey/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SurveyApi - functional programming interface
 * @export
 */
export var SurveyApiFp = function (configuration) {
    return {
        /**
         * count survey by search conditions
         * @summary count survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSurvey: function (options) {
            var localVarAxiosArgs = SurveyApiAxiosParamCreator(configuration).countSurvey(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create survey
         * @summary create survey
         * @param {ModelSurvey} body Survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: function (body, options) {
            var localVarAxiosArgs = SurveyApiAxiosParamCreator(configuration).createSurvey(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete survey
         * @summary delete survey
         * @param {number} id SurveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey: function (id, options) {
            var localVarAxiosArgs = SurveyApiAxiosParamCreator(configuration).deleteSurvey(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get survey
         * @summary get survey
         * @param {number} id SurveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: function (id, options) {
            var localVarAxiosArgs = SurveyApiAxiosParamCreator(configuration).getSurvey(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch survey
         * @summary patch survey
         * @param {number} id SurveyID
         * @param {ModelSurvey} body Survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSurvey: function (id, body, options) {
            var localVarAxiosArgs = SurveyApiAxiosParamCreator(configuration).patchSurvey(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search survey by search conditions
         * @summary search survey
         * @param {string} [tenantID] tenantID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSurvey: function (tenantID, options) {
            var localVarAxiosArgs = SurveyApiAxiosParamCreator(configuration).searchSurvey(tenantID, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update survey
         * @summary update survey
         * @param {number} id SurveyID
         * @param {ModelSurvey} body Survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey: function (id, body, options) {
            var localVarAxiosArgs = SurveyApiAxiosParamCreator(configuration).updateSurvey(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * SurveyApi - factory interface
 * @export
 */
export var SurveyApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count survey by search conditions
         * @summary count survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSurvey: function (options) {
            return SurveyApiFp(configuration).countSurvey(options)(axios, basePath);
        },
        /**
         * create survey
         * @summary create survey
         * @param {ModelSurvey} body Survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: function (body, options) {
            return SurveyApiFp(configuration).createSurvey(body, options)(axios, basePath);
        },
        /**
         * delete survey
         * @summary delete survey
         * @param {number} id SurveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey: function (id, options) {
            return SurveyApiFp(configuration).deleteSurvey(id, options)(axios, basePath);
        },
        /**
         * get survey
         * @summary get survey
         * @param {number} id SurveyID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurvey: function (id, options) {
            return SurveyApiFp(configuration).getSurvey(id, options)(axios, basePath);
        },
        /**
         * patch survey
         * @summary patch survey
         * @param {number} id SurveyID
         * @param {ModelSurvey} body Survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSurvey: function (id, body, options) {
            return SurveyApiFp(configuration).patchSurvey(id, body, options)(axios, basePath);
        },
        /**
         * search survey by search conditions
         * @summary search survey
         * @param {string} [tenantID] tenantID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSurvey: function (tenantID, options) {
            return SurveyApiFp(configuration).searchSurvey(tenantID, options)(axios, basePath);
        },
        /**
         * update survey
         * @summary update survey
         * @param {number} id SurveyID
         * @param {ModelSurvey} body Survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey: function (id, body, options) {
            return SurveyApiFp(configuration).updateSurvey(id, body, options)(axios, basePath);
        },
    };
};
/**
 * SurveyApi - object-oriented interface
 * @export
 * @class SurveyApi
 * @extends {BaseAPI}
 */
var SurveyApi = /** @class */ (function (_super) {
    __extends(SurveyApi, _super);
    function SurveyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count survey by search conditions
     * @summary count survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    SurveyApi.prototype.countSurvey = function (options) {
        return SurveyApiFp(this.configuration).countSurvey(options)(this.axios, this.basePath);
    };
    /**
     * create survey
     * @summary create survey
     * @param {ModelSurvey} body Survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    SurveyApi.prototype.createSurvey = function (body, options) {
        return SurveyApiFp(this.configuration).createSurvey(body, options)(this.axios, this.basePath);
    };
    /**
     * delete survey
     * @summary delete survey
     * @param {number} id SurveyID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    SurveyApi.prototype.deleteSurvey = function (id, options) {
        return SurveyApiFp(this.configuration).deleteSurvey(id, options)(this.axios, this.basePath);
    };
    /**
     * get survey
     * @summary get survey
     * @param {number} id SurveyID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    SurveyApi.prototype.getSurvey = function (id, options) {
        return SurveyApiFp(this.configuration).getSurvey(id, options)(this.axios, this.basePath);
    };
    /**
     * patch survey
     * @summary patch survey
     * @param {number} id SurveyID
     * @param {ModelSurvey} body Survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    SurveyApi.prototype.patchSurvey = function (id, body, options) {
        return SurveyApiFp(this.configuration).patchSurvey(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search survey by search conditions
     * @summary search survey
     * @param {string} [tenantID] tenantID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    SurveyApi.prototype.searchSurvey = function (tenantID, options) {
        return SurveyApiFp(this.configuration).searchSurvey(tenantID, options)(this.axios, this.basePath);
    };
    /**
     * update survey
     * @summary update survey
     * @param {number} id SurveyID
     * @param {ModelSurvey} body Survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    SurveyApi.prototype.updateSurvey = function (id, body, options) {
        return SurveyApiFp(this.configuration).updateSurvey(id, body, options)(this.axios, this.basePath);
    };
    return SurveyApi;
}(BaseAPI));
export { SurveyApi };
/**
 * TargetGroupApi - axios parameter creator
 * @export
 */
export var TargetGroupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count targetGroup by search conditions
         * @summary count targetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTargetGroup: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/targetGroups/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create targetGroup
         * @summary create targetGroup
         * @param {ModelTargetGroup} body TargetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTargetGroup: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createTargetGroup.');
            }
            var localVarPath = "/targetGroup";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete targetGroup
         * @summary delete targetGroup
         * @param {number} id TargetGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTargetGroup: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTargetGroup.');
            }
            var localVarPath = "/targetGroup/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get targetGroup
         * @summary get targetGroup
         * @param {number} id TargetGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetGroup: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getTargetGroup.');
            }
            var localVarPath = "/targetGroup/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch targetGroup
         * @summary patch targetGroup
         * @param {number} id TargetGroupID
         * @param {ModelTargetGroup} body TargetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTargetGroup: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchTargetGroup.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchTargetGroup.');
            }
            var localVarPath = "/targetGroup/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search targetGroup by search conditions
         * @summary search targetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTargetGroup: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/targetGroups";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update targetGroup
         * @summary update targetGroup
         * @param {number} id TargetGroupID
         * @param {ModelTargetGroup} body TargetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTargetGroup: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateTargetGroup.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateTargetGroup.');
            }
            var localVarPath = "/targetGroup/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TargetGroupApi - functional programming interface
 * @export
 */
export var TargetGroupApiFp = function (configuration) {
    return {
        /**
         * count targetGroup by search conditions
         * @summary count targetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTargetGroup: function (options) {
            var localVarAxiosArgs = TargetGroupApiAxiosParamCreator(configuration).countTargetGroup(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create targetGroup
         * @summary create targetGroup
         * @param {ModelTargetGroup} body TargetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTargetGroup: function (body, options) {
            var localVarAxiosArgs = TargetGroupApiAxiosParamCreator(configuration).createTargetGroup(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete targetGroup
         * @summary delete targetGroup
         * @param {number} id TargetGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTargetGroup: function (id, options) {
            var localVarAxiosArgs = TargetGroupApiAxiosParamCreator(configuration).deleteTargetGroup(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get targetGroup
         * @summary get targetGroup
         * @param {number} id TargetGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetGroup: function (id, options) {
            var localVarAxiosArgs = TargetGroupApiAxiosParamCreator(configuration).getTargetGroup(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch targetGroup
         * @summary patch targetGroup
         * @param {number} id TargetGroupID
         * @param {ModelTargetGroup} body TargetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTargetGroup: function (id, body, options) {
            var localVarAxiosArgs = TargetGroupApiAxiosParamCreator(configuration).patchTargetGroup(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search targetGroup by search conditions
         * @summary search targetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTargetGroup: function (options) {
            var localVarAxiosArgs = TargetGroupApiAxiosParamCreator(configuration).searchTargetGroup(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update targetGroup
         * @summary update targetGroup
         * @param {number} id TargetGroupID
         * @param {ModelTargetGroup} body TargetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTargetGroup: function (id, body, options) {
            var localVarAxiosArgs = TargetGroupApiAxiosParamCreator(configuration).updateTargetGroup(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * TargetGroupApi - factory interface
 * @export
 */
export var TargetGroupApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count targetGroup by search conditions
         * @summary count targetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTargetGroup: function (options) {
            return TargetGroupApiFp(configuration).countTargetGroup(options)(axios, basePath);
        },
        /**
         * create targetGroup
         * @summary create targetGroup
         * @param {ModelTargetGroup} body TargetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTargetGroup: function (body, options) {
            return TargetGroupApiFp(configuration).createTargetGroup(body, options)(axios, basePath);
        },
        /**
         * delete targetGroup
         * @summary delete targetGroup
         * @param {number} id TargetGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTargetGroup: function (id, options) {
            return TargetGroupApiFp(configuration).deleteTargetGroup(id, options)(axios, basePath);
        },
        /**
         * get targetGroup
         * @summary get targetGroup
         * @param {number} id TargetGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetGroup: function (id, options) {
            return TargetGroupApiFp(configuration).getTargetGroup(id, options)(axios, basePath);
        },
        /**
         * patch targetGroup
         * @summary patch targetGroup
         * @param {number} id TargetGroupID
         * @param {ModelTargetGroup} body TargetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTargetGroup: function (id, body, options) {
            return TargetGroupApiFp(configuration).patchTargetGroup(id, body, options)(axios, basePath);
        },
        /**
         * search targetGroup by search conditions
         * @summary search targetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTargetGroup: function (options) {
            return TargetGroupApiFp(configuration).searchTargetGroup(options)(axios, basePath);
        },
        /**
         * update targetGroup
         * @summary update targetGroup
         * @param {number} id TargetGroupID
         * @param {ModelTargetGroup} body TargetGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTargetGroup: function (id, body, options) {
            return TargetGroupApiFp(configuration).updateTargetGroup(id, body, options)(axios, basePath);
        },
    };
};
/**
 * TargetGroupApi - object-oriented interface
 * @export
 * @class TargetGroupApi
 * @extends {BaseAPI}
 */
var TargetGroupApi = /** @class */ (function (_super) {
    __extends(TargetGroupApi, _super);
    function TargetGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count targetGroup by search conditions
     * @summary count targetGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetGroupApi
     */
    TargetGroupApi.prototype.countTargetGroup = function (options) {
        return TargetGroupApiFp(this.configuration).countTargetGroup(options)(this.axios, this.basePath);
    };
    /**
     * create targetGroup
     * @summary create targetGroup
     * @param {ModelTargetGroup} body TargetGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetGroupApi
     */
    TargetGroupApi.prototype.createTargetGroup = function (body, options) {
        return TargetGroupApiFp(this.configuration).createTargetGroup(body, options)(this.axios, this.basePath);
    };
    /**
     * delete targetGroup
     * @summary delete targetGroup
     * @param {number} id TargetGroupID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetGroupApi
     */
    TargetGroupApi.prototype.deleteTargetGroup = function (id, options) {
        return TargetGroupApiFp(this.configuration).deleteTargetGroup(id, options)(this.axios, this.basePath);
    };
    /**
     * get targetGroup
     * @summary get targetGroup
     * @param {number} id TargetGroupID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetGroupApi
     */
    TargetGroupApi.prototype.getTargetGroup = function (id, options) {
        return TargetGroupApiFp(this.configuration).getTargetGroup(id, options)(this.axios, this.basePath);
    };
    /**
     * patch targetGroup
     * @summary patch targetGroup
     * @param {number} id TargetGroupID
     * @param {ModelTargetGroup} body TargetGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetGroupApi
     */
    TargetGroupApi.prototype.patchTargetGroup = function (id, body, options) {
        return TargetGroupApiFp(this.configuration).patchTargetGroup(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search targetGroup by search conditions
     * @summary search targetGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetGroupApi
     */
    TargetGroupApi.prototype.searchTargetGroup = function (options) {
        return TargetGroupApiFp(this.configuration).searchTargetGroup(options)(this.axios, this.basePath);
    };
    /**
     * update targetGroup
     * @summary update targetGroup
     * @param {number} id TargetGroupID
     * @param {ModelTargetGroup} body TargetGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetGroupApi
     */
    TargetGroupApi.prototype.updateTargetGroup = function (id, body, options) {
        return TargetGroupApiFp(this.configuration).updateTargetGroup(id, body, options)(this.axios, this.basePath);
    };
    return TargetGroupApi;
}(BaseAPI));
export { TargetGroupApi };
/**
 * TargetUserApi - axios parameter creator
 * @export
 */
export var TargetUserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count targetUser by search conditions
         * @summary count targetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTargetUser: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/targetUsers/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create targetUser
         * @summary create targetUser
         * @param {ModelTargetUser} body TargetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTargetUser: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createTargetUser.');
            }
            var localVarPath = "/targetUser";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete targetUser
         * @summary delete targetUser
         * @param {number} id TargetUserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTargetUser: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTargetUser.');
            }
            var localVarPath = "/targetUser/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get targetUser
         * @summary get targetUser
         * @param {number} id TargetUserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetUser: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getTargetUser.');
            }
            var localVarPath = "/targetUser/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch targetUser
         * @summary patch targetUser
         * @param {number} id TargetUserID
         * @param {ModelTargetUser} body TargetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTargetUser: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchTargetUser.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchTargetUser.');
            }
            var localVarPath = "/targetUser/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search targetUser by search conditions
         * @summary search targetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTargetUser: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/targetUsers";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update targetUser
         * @summary update targetUser
         * @param {number} id TargetUserID
         * @param {ModelTargetUser} body TargetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTargetUser: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateTargetUser.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateTargetUser.');
            }
            var localVarPath = "/targetUser/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TargetUserApi - functional programming interface
 * @export
 */
export var TargetUserApiFp = function (configuration) {
    return {
        /**
         * count targetUser by search conditions
         * @summary count targetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTargetUser: function (options) {
            var localVarAxiosArgs = TargetUserApiAxiosParamCreator(configuration).countTargetUser(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create targetUser
         * @summary create targetUser
         * @param {ModelTargetUser} body TargetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTargetUser: function (body, options) {
            var localVarAxiosArgs = TargetUserApiAxiosParamCreator(configuration).createTargetUser(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete targetUser
         * @summary delete targetUser
         * @param {number} id TargetUserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTargetUser: function (id, options) {
            var localVarAxiosArgs = TargetUserApiAxiosParamCreator(configuration).deleteTargetUser(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get targetUser
         * @summary get targetUser
         * @param {number} id TargetUserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetUser: function (id, options) {
            var localVarAxiosArgs = TargetUserApiAxiosParamCreator(configuration).getTargetUser(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch targetUser
         * @summary patch targetUser
         * @param {number} id TargetUserID
         * @param {ModelTargetUser} body TargetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTargetUser: function (id, body, options) {
            var localVarAxiosArgs = TargetUserApiAxiosParamCreator(configuration).patchTargetUser(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search targetUser by search conditions
         * @summary search targetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTargetUser: function (options) {
            var localVarAxiosArgs = TargetUserApiAxiosParamCreator(configuration).searchTargetUser(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update targetUser
         * @summary update targetUser
         * @param {number} id TargetUserID
         * @param {ModelTargetUser} body TargetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTargetUser: function (id, body, options) {
            var localVarAxiosArgs = TargetUserApiAxiosParamCreator(configuration).updateTargetUser(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * TargetUserApi - factory interface
 * @export
 */
export var TargetUserApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count targetUser by search conditions
         * @summary count targetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTargetUser: function (options) {
            return TargetUserApiFp(configuration).countTargetUser(options)(axios, basePath);
        },
        /**
         * create targetUser
         * @summary create targetUser
         * @param {ModelTargetUser} body TargetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTargetUser: function (body, options) {
            return TargetUserApiFp(configuration).createTargetUser(body, options)(axios, basePath);
        },
        /**
         * delete targetUser
         * @summary delete targetUser
         * @param {number} id TargetUserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTargetUser: function (id, options) {
            return TargetUserApiFp(configuration).deleteTargetUser(id, options)(axios, basePath);
        },
        /**
         * get targetUser
         * @summary get targetUser
         * @param {number} id TargetUserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTargetUser: function (id, options) {
            return TargetUserApiFp(configuration).getTargetUser(id, options)(axios, basePath);
        },
        /**
         * patch targetUser
         * @summary patch targetUser
         * @param {number} id TargetUserID
         * @param {ModelTargetUser} body TargetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTargetUser: function (id, body, options) {
            return TargetUserApiFp(configuration).patchTargetUser(id, body, options)(axios, basePath);
        },
        /**
         * search targetUser by search conditions
         * @summary search targetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTargetUser: function (options) {
            return TargetUserApiFp(configuration).searchTargetUser(options)(axios, basePath);
        },
        /**
         * update targetUser
         * @summary update targetUser
         * @param {number} id TargetUserID
         * @param {ModelTargetUser} body TargetUser
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTargetUser: function (id, body, options) {
            return TargetUserApiFp(configuration).updateTargetUser(id, body, options)(axios, basePath);
        },
    };
};
/**
 * TargetUserApi - object-oriented interface
 * @export
 * @class TargetUserApi
 * @extends {BaseAPI}
 */
var TargetUserApi = /** @class */ (function (_super) {
    __extends(TargetUserApi, _super);
    function TargetUserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count targetUser by search conditions
     * @summary count targetUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetUserApi
     */
    TargetUserApi.prototype.countTargetUser = function (options) {
        return TargetUserApiFp(this.configuration).countTargetUser(options)(this.axios, this.basePath);
    };
    /**
     * create targetUser
     * @summary create targetUser
     * @param {ModelTargetUser} body TargetUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetUserApi
     */
    TargetUserApi.prototype.createTargetUser = function (body, options) {
        return TargetUserApiFp(this.configuration).createTargetUser(body, options)(this.axios, this.basePath);
    };
    /**
     * delete targetUser
     * @summary delete targetUser
     * @param {number} id TargetUserID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetUserApi
     */
    TargetUserApi.prototype.deleteTargetUser = function (id, options) {
        return TargetUserApiFp(this.configuration).deleteTargetUser(id, options)(this.axios, this.basePath);
    };
    /**
     * get targetUser
     * @summary get targetUser
     * @param {number} id TargetUserID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetUserApi
     */
    TargetUserApi.prototype.getTargetUser = function (id, options) {
        return TargetUserApiFp(this.configuration).getTargetUser(id, options)(this.axios, this.basePath);
    };
    /**
     * patch targetUser
     * @summary patch targetUser
     * @param {number} id TargetUserID
     * @param {ModelTargetUser} body TargetUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetUserApi
     */
    TargetUserApi.prototype.patchTargetUser = function (id, body, options) {
        return TargetUserApiFp(this.configuration).patchTargetUser(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search targetUser by search conditions
     * @summary search targetUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetUserApi
     */
    TargetUserApi.prototype.searchTargetUser = function (options) {
        return TargetUserApiFp(this.configuration).searchTargetUser(options)(this.axios, this.basePath);
    };
    /**
     * update targetUser
     * @summary update targetUser
     * @param {number} id TargetUserID
     * @param {ModelTargetUser} body TargetUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TargetUserApi
     */
    TargetUserApi.prototype.updateTargetUser = function (id, body, options) {
        return TargetUserApiFp(this.configuration).updateTargetUser(id, body, options)(this.axios, this.basePath);
    };
    return TargetUserApi;
}(BaseAPI));
export { TargetUserApi };
/**
 * TenantApi - axios parameter creator
 * @export
 */
export var TenantApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count tenant by search conditions
         * @summary count tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTenant: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/tenants/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create tenant
         * @summary create tenant
         * @param {ModelTenant} body Tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenant: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createTenant.');
            }
            var localVarPath = "/tenant";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete tenant
         * @summary delete tenant
         * @param {number} id TenantID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTenant: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTenant.');
            }
            var localVarPath = "/tenant/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get tenant
         * @summary get tenant
         * @param {number} id TenantID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenant: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getTenant.');
            }
            var localVarPath = "/tenant/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch tenant
         * @summary patch tenant
         * @param {number} id TenantID
         * @param {ModelTenant} body Tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTenant: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchTenant.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchTenant.');
            }
            var localVarPath = "/tenant/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search tenant by search conditions
         * @summary search tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTenant: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/tenants";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update tenant
         * @summary update tenant
         * @param {number} id TenantID
         * @param {ModelTenant} body Tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenant: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateTenant.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateTenant.');
            }
            var localVarPath = "/tenant/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TenantApi - functional programming interface
 * @export
 */
export var TenantApiFp = function (configuration) {
    return {
        /**
         * count tenant by search conditions
         * @summary count tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTenant: function (options) {
            var localVarAxiosArgs = TenantApiAxiosParamCreator(configuration).countTenant(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create tenant
         * @summary create tenant
         * @param {ModelTenant} body Tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenant: function (body, options) {
            var localVarAxiosArgs = TenantApiAxiosParamCreator(configuration).createTenant(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete tenant
         * @summary delete tenant
         * @param {number} id TenantID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTenant: function (id, options) {
            var localVarAxiosArgs = TenantApiAxiosParamCreator(configuration).deleteTenant(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get tenant
         * @summary get tenant
         * @param {number} id TenantID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenant: function (id, options) {
            var localVarAxiosArgs = TenantApiAxiosParamCreator(configuration).getTenant(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch tenant
         * @summary patch tenant
         * @param {number} id TenantID
         * @param {ModelTenant} body Tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTenant: function (id, body, options) {
            var localVarAxiosArgs = TenantApiAxiosParamCreator(configuration).patchTenant(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search tenant by search conditions
         * @summary search tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTenant: function (options) {
            var localVarAxiosArgs = TenantApiAxiosParamCreator(configuration).searchTenant(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update tenant
         * @summary update tenant
         * @param {number} id TenantID
         * @param {ModelTenant} body Tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenant: function (id, body, options) {
            var localVarAxiosArgs = TenantApiAxiosParamCreator(configuration).updateTenant(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * TenantApi - factory interface
 * @export
 */
export var TenantApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count tenant by search conditions
         * @summary count tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTenant: function (options) {
            return TenantApiFp(configuration).countTenant(options)(axios, basePath);
        },
        /**
         * create tenant
         * @summary create tenant
         * @param {ModelTenant} body Tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenant: function (body, options) {
            return TenantApiFp(configuration).createTenant(body, options)(axios, basePath);
        },
        /**
         * delete tenant
         * @summary delete tenant
         * @param {number} id TenantID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTenant: function (id, options) {
            return TenantApiFp(configuration).deleteTenant(id, options)(axios, basePath);
        },
        /**
         * get tenant
         * @summary get tenant
         * @param {number} id TenantID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenant: function (id, options) {
            return TenantApiFp(configuration).getTenant(id, options)(axios, basePath);
        },
        /**
         * patch tenant
         * @summary patch tenant
         * @param {number} id TenantID
         * @param {ModelTenant} body Tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTenant: function (id, body, options) {
            return TenantApiFp(configuration).patchTenant(id, body, options)(axios, basePath);
        },
        /**
         * search tenant by search conditions
         * @summary search tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTenant: function (options) {
            return TenantApiFp(configuration).searchTenant(options)(axios, basePath);
        },
        /**
         * update tenant
         * @summary update tenant
         * @param {number} id TenantID
         * @param {ModelTenant} body Tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenant: function (id, body, options) {
            return TenantApiFp(configuration).updateTenant(id, body, options)(axios, basePath);
        },
    };
};
/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
var TenantApi = /** @class */ (function (_super) {
    __extends(TenantApi, _super);
    function TenantApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count tenant by search conditions
     * @summary count tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    TenantApi.prototype.countTenant = function (options) {
        return TenantApiFp(this.configuration).countTenant(options)(this.axios, this.basePath);
    };
    /**
     * create tenant
     * @summary create tenant
     * @param {ModelTenant} body Tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    TenantApi.prototype.createTenant = function (body, options) {
        return TenantApiFp(this.configuration).createTenant(body, options)(this.axios, this.basePath);
    };
    /**
     * delete tenant
     * @summary delete tenant
     * @param {number} id TenantID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    TenantApi.prototype.deleteTenant = function (id, options) {
        return TenantApiFp(this.configuration).deleteTenant(id, options)(this.axios, this.basePath);
    };
    /**
     * get tenant
     * @summary get tenant
     * @param {number} id TenantID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    TenantApi.prototype.getTenant = function (id, options) {
        return TenantApiFp(this.configuration).getTenant(id, options)(this.axios, this.basePath);
    };
    /**
     * patch tenant
     * @summary patch tenant
     * @param {number} id TenantID
     * @param {ModelTenant} body Tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    TenantApi.prototype.patchTenant = function (id, body, options) {
        return TenantApiFp(this.configuration).patchTenant(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search tenant by search conditions
     * @summary search tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    TenantApi.prototype.searchTenant = function (options) {
        return TenantApiFp(this.configuration).searchTenant(options)(this.axios, this.basePath);
    };
    /**
     * update tenant
     * @summary update tenant
     * @param {number} id TenantID
     * @param {ModelTenant} body Tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    TenantApi.prototype.updateTenant = function (id, body, options) {
        return TenantApiFp(this.configuration).updateTenant(id, body, options)(this.axios, this.basePath);
    };
    return TenantApi;
}(BaseAPI));
export { TenantApi };
/**
 * TypeGroupApi - axios parameter creator
 * @export
 */
export var TypeGroupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count typeGroup by search conditions
         * @summary count typeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTypeGroup: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/typeGroups/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create typeGroup
         * @summary create typeGroup
         * @param {ModelTypeGroup} body TypeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTypeGroup: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createTypeGroup.');
            }
            var localVarPath = "/typeGroup";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete typeGroup
         * @summary delete typeGroup
         * @param {number} id TypeGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTypeGroup: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTypeGroup.');
            }
            var localVarPath = "/typeGroup/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get typeGroup
         * @summary get typeGroup
         * @param {number} id TypeGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypeGroup: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getTypeGroup.');
            }
            var localVarPath = "/typeGroup/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch typeGroup
         * @summary patch typeGroup
         * @param {number} id TypeGroupID
         * @param {ModelTypeGroup} body TypeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTypeGroup: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchTypeGroup.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchTypeGroup.');
            }
            var localVarPath = "/typeGroup/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search typeGroup by search conditions
         * @summary search typeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTypeGroup: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/typeGroups";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update typeGroup
         * @summary update typeGroup
         * @param {number} id TypeGroupID
         * @param {ModelTypeGroup} body TypeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTypeGroup: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateTypeGroup.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateTypeGroup.');
            }
            var localVarPath = "/typeGroup/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TypeGroupApi - functional programming interface
 * @export
 */
export var TypeGroupApiFp = function (configuration) {
    return {
        /**
         * count typeGroup by search conditions
         * @summary count typeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTypeGroup: function (options) {
            var localVarAxiosArgs = TypeGroupApiAxiosParamCreator(configuration).countTypeGroup(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create typeGroup
         * @summary create typeGroup
         * @param {ModelTypeGroup} body TypeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTypeGroup: function (body, options) {
            var localVarAxiosArgs = TypeGroupApiAxiosParamCreator(configuration).createTypeGroup(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete typeGroup
         * @summary delete typeGroup
         * @param {number} id TypeGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTypeGroup: function (id, options) {
            var localVarAxiosArgs = TypeGroupApiAxiosParamCreator(configuration).deleteTypeGroup(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get typeGroup
         * @summary get typeGroup
         * @param {number} id TypeGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypeGroup: function (id, options) {
            var localVarAxiosArgs = TypeGroupApiAxiosParamCreator(configuration).getTypeGroup(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch typeGroup
         * @summary patch typeGroup
         * @param {number} id TypeGroupID
         * @param {ModelTypeGroup} body TypeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTypeGroup: function (id, body, options) {
            var localVarAxiosArgs = TypeGroupApiAxiosParamCreator(configuration).patchTypeGroup(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search typeGroup by search conditions
         * @summary search typeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTypeGroup: function (options) {
            var localVarAxiosArgs = TypeGroupApiAxiosParamCreator(configuration).searchTypeGroup(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update typeGroup
         * @summary update typeGroup
         * @param {number} id TypeGroupID
         * @param {ModelTypeGroup} body TypeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTypeGroup: function (id, body, options) {
            var localVarAxiosArgs = TypeGroupApiAxiosParamCreator(configuration).updateTypeGroup(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * TypeGroupApi - factory interface
 * @export
 */
export var TypeGroupApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count typeGroup by search conditions
         * @summary count typeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countTypeGroup: function (options) {
            return TypeGroupApiFp(configuration).countTypeGroup(options)(axios, basePath);
        },
        /**
         * create typeGroup
         * @summary create typeGroup
         * @param {ModelTypeGroup} body TypeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTypeGroup: function (body, options) {
            return TypeGroupApiFp(configuration).createTypeGroup(body, options)(axios, basePath);
        },
        /**
         * delete typeGroup
         * @summary delete typeGroup
         * @param {number} id TypeGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTypeGroup: function (id, options) {
            return TypeGroupApiFp(configuration).deleteTypeGroup(id, options)(axios, basePath);
        },
        /**
         * get typeGroup
         * @summary get typeGroup
         * @param {number} id TypeGroupID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypeGroup: function (id, options) {
            return TypeGroupApiFp(configuration).getTypeGroup(id, options)(axios, basePath);
        },
        /**
         * patch typeGroup
         * @summary patch typeGroup
         * @param {number} id TypeGroupID
         * @param {ModelTypeGroup} body TypeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTypeGroup: function (id, body, options) {
            return TypeGroupApiFp(configuration).patchTypeGroup(id, body, options)(axios, basePath);
        },
        /**
         * search typeGroup by search conditions
         * @summary search typeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTypeGroup: function (options) {
            return TypeGroupApiFp(configuration).searchTypeGroup(options)(axios, basePath);
        },
        /**
         * update typeGroup
         * @summary update typeGroup
         * @param {number} id TypeGroupID
         * @param {ModelTypeGroup} body TypeGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTypeGroup: function (id, body, options) {
            return TypeGroupApiFp(configuration).updateTypeGroup(id, body, options)(axios, basePath);
        },
    };
};
/**
 * TypeGroupApi - object-oriented interface
 * @export
 * @class TypeGroupApi
 * @extends {BaseAPI}
 */
var TypeGroupApi = /** @class */ (function (_super) {
    __extends(TypeGroupApi, _super);
    function TypeGroupApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count typeGroup by search conditions
     * @summary count typeGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeGroupApi
     */
    TypeGroupApi.prototype.countTypeGroup = function (options) {
        return TypeGroupApiFp(this.configuration).countTypeGroup(options)(this.axios, this.basePath);
    };
    /**
     * create typeGroup
     * @summary create typeGroup
     * @param {ModelTypeGroup} body TypeGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeGroupApi
     */
    TypeGroupApi.prototype.createTypeGroup = function (body, options) {
        return TypeGroupApiFp(this.configuration).createTypeGroup(body, options)(this.axios, this.basePath);
    };
    /**
     * delete typeGroup
     * @summary delete typeGroup
     * @param {number} id TypeGroupID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeGroupApi
     */
    TypeGroupApi.prototype.deleteTypeGroup = function (id, options) {
        return TypeGroupApiFp(this.configuration).deleteTypeGroup(id, options)(this.axios, this.basePath);
    };
    /**
     * get typeGroup
     * @summary get typeGroup
     * @param {number} id TypeGroupID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeGroupApi
     */
    TypeGroupApi.prototype.getTypeGroup = function (id, options) {
        return TypeGroupApiFp(this.configuration).getTypeGroup(id, options)(this.axios, this.basePath);
    };
    /**
     * patch typeGroup
     * @summary patch typeGroup
     * @param {number} id TypeGroupID
     * @param {ModelTypeGroup} body TypeGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeGroupApi
     */
    TypeGroupApi.prototype.patchTypeGroup = function (id, body, options) {
        return TypeGroupApiFp(this.configuration).patchTypeGroup(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search typeGroup by search conditions
     * @summary search typeGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeGroupApi
     */
    TypeGroupApi.prototype.searchTypeGroup = function (options) {
        return TypeGroupApiFp(this.configuration).searchTypeGroup(options)(this.axios, this.basePath);
    };
    /**
     * update typeGroup
     * @summary update typeGroup
     * @param {number} id TypeGroupID
     * @param {ModelTypeGroup} body TypeGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypeGroupApi
     */
    TypeGroupApi.prototype.updateTypeGroup = function (id, body, options) {
        return TypeGroupApiFp(this.configuration).updateTypeGroup(id, body, options)(this.axios, this.basePath);
    };
    return TypeGroupApi;
}(BaseAPI));
export { TypeGroupApi };
/**
 * UserApi - axios parameter creator
 * @export
 */
export var UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count user by search conditions
         * @summary count user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/users/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create user
         * @summary create user
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createUser.');
            }
            var localVarPath = "/user";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete user
         * @summary delete user
         * @param {number} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteUser.');
            }
            var localVarPath = "/user/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get user
         * @summary get user
         * @param {number} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getUser.');
            }
            var localVarPath = "/user/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch user
         * @summary patch user
         * @param {number} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchUser.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchUser.');
            }
            var localVarPath = "/user/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search user by search conditions
         * @summary search user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/users";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update user
         * @summary update user
         * @param {number} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateUser.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateUser.');
            }
            var localVarPath = "/user/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserApi - functional programming interface
 * @export
 */
export var UserApiFp = function (configuration) {
    return {
        /**
         * count user by search conditions
         * @summary count user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser: function (options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).countUser(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create user
         * @summary create user
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (body, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).createUser(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete user
         * @summary delete user
         * @param {number} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (id, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).deleteUser(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get user
         * @summary get user
         * @param {number} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (id, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).getUser(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch user
         * @summary patch user
         * @param {number} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser: function (id, body, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).patchUser(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search user by search conditions
         * @summary search user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: function (options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).searchUser(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update user
         * @summary update user
         * @param {number} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (id, body, options) {
            var localVarAxiosArgs = UserApiAxiosParamCreator(configuration).updateUser(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UserApi - factory interface
 * @export
 */
export var UserApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count user by search conditions
         * @summary count user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser: function (options) {
            return UserApiFp(configuration).countUser(options)(axios, basePath);
        },
        /**
         * create user
         * @summary create user
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (body, options) {
            return UserApiFp(configuration).createUser(body, options)(axios, basePath);
        },
        /**
         * delete user
         * @summary delete user
         * @param {number} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (id, options) {
            return UserApiFp(configuration).deleteUser(id, options)(axios, basePath);
        },
        /**
         * get user
         * @summary get user
         * @param {number} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (id, options) {
            return UserApiFp(configuration).getUser(id, options)(axios, basePath);
        },
        /**
         * patch user
         * @summary patch user
         * @param {number} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser: function (id, body, options) {
            return UserApiFp(configuration).patchUser(id, body, options)(axios, basePath);
        },
        /**
         * search user by search conditions
         * @summary search user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: function (options) {
            return UserApiFp(configuration).searchUser(options)(axios, basePath);
        },
        /**
         * update user
         * @summary update user
         * @param {number} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (id, body, options) {
            return UserApiFp(configuration).updateUser(id, body, options)(axios, basePath);
        },
    };
};
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count user by search conditions
     * @summary count user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.countUser = function (options) {
        return UserApiFp(this.configuration).countUser(options)(this.axios, this.basePath);
    };
    /**
     * create user
     * @summary create user
     * @param {ModelUser} body User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.createUser = function (body, options) {
        return UserApiFp(this.configuration).createUser(body, options)(this.axios, this.basePath);
    };
    /**
     * delete user
     * @summary delete user
     * @param {number} id UserID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.deleteUser = function (id, options) {
        return UserApiFp(this.configuration).deleteUser(id, options)(this.axios, this.basePath);
    };
    /**
     * get user
     * @summary get user
     * @param {number} id UserID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.getUser = function (id, options) {
        return UserApiFp(this.configuration).getUser(id, options)(this.axios, this.basePath);
    };
    /**
     * patch user
     * @summary patch user
     * @param {number} id UserID
     * @param {ModelUser} body User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.patchUser = function (id, body, options) {
        return UserApiFp(this.configuration).patchUser(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search user by search conditions
     * @summary search user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.searchUser = function (options) {
        return UserApiFp(this.configuration).searchUser(options)(this.axios, this.basePath);
    };
    /**
     * update user
     * @summary update user
     * @param {number} id UserID
     * @param {ModelUser} body User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.updateUser = function (id, body, options) {
        return UserApiFp(this.configuration).updateUser(id, body, options)(this.axios, this.basePath);
    };
    return UserApi;
}(BaseAPI));
export { UserApi };
/**
 * UserScenarioApi - axios parameter creator
 * @export
 */
export var UserScenarioApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * count userScenario by search conditions
         * @summary count userScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUserScenario: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/userScenarios/count";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create userScenario
         * @summary create userScenario
         * @param {ModelUserScenario} body UserScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserScenario: function (body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling createUserScenario.');
            }
            var localVarPath = "/userScenario";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * delete userScenario
         * @summary delete userScenario
         * @param {number} id UserScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserScenario: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteUserScenario.');
            }
            var localVarPath = "/userScenario/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get userScenario
         * @summary get userScenario
         * @param {number} id UserScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserScenario: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getUserScenario.');
            }
            var localVarPath = "/userScenario/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * patch userScenario
         * @summary patch userScenario
         * @param {number} id UserScenarioID
         * @param {ModelUserScenario} body UserScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserScenario: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchUserScenario.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchUserScenario.');
            }
            var localVarPath = "/userScenario/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * search userScenario by search conditions
         * @summary search userScenario
         * @param {string} [nextTime] example:2006-01-02T15:04:05Z07:00
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserScenario: function (nextTime, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/userScenarios";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (nextTime !== undefined) {
                localVarQueryParameter['nextTime'] = nextTime;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update userScenario
         * @summary update userScenario
         * @param {number} id UserScenarioID
         * @param {ModelUserScenario} body UserScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserScenario: function (id, body, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateUserScenario.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateUserScenario.');
            }
            var localVarPath = "/userScenario/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            var headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            var needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserScenarioApi - functional programming interface
 * @export
 */
export var UserScenarioApiFp = function (configuration) {
    return {
        /**
         * count userScenario by search conditions
         * @summary count userScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUserScenario: function (options) {
            var localVarAxiosArgs = UserScenarioApiAxiosParamCreator(configuration).countUserScenario(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * create userScenario
         * @summary create userScenario
         * @param {ModelUserScenario} body UserScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserScenario: function (body, options) {
            var localVarAxiosArgs = UserScenarioApiAxiosParamCreator(configuration).createUserScenario(body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * delete userScenario
         * @summary delete userScenario
         * @param {number} id UserScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserScenario: function (id, options) {
            var localVarAxiosArgs = UserScenarioApiAxiosParamCreator(configuration).deleteUserScenario(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * get userScenario
         * @summary get userScenario
         * @param {number} id UserScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserScenario: function (id, options) {
            var localVarAxiosArgs = UserScenarioApiAxiosParamCreator(configuration).getUserScenario(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * patch userScenario
         * @summary patch userScenario
         * @param {number} id UserScenarioID
         * @param {ModelUserScenario} body UserScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserScenario: function (id, body, options) {
            var localVarAxiosArgs = UserScenarioApiAxiosParamCreator(configuration).patchUserScenario(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * search userScenario by search conditions
         * @summary search userScenario
         * @param {string} [nextTime] example:2006-01-02T15:04:05Z07:00
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserScenario: function (nextTime, options) {
            var localVarAxiosArgs = UserScenarioApiAxiosParamCreator(configuration).searchUserScenario(nextTime, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * update userScenario
         * @summary update userScenario
         * @param {number} id UserScenarioID
         * @param {ModelUserScenario} body UserScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserScenario: function (id, body, options) {
            var localVarAxiosArgs = UserScenarioApiAxiosParamCreator(configuration).updateUserScenario(id, body, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = globalAxios; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UserScenarioApi - factory interface
 * @export
 */
export var UserScenarioApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count userScenario by search conditions
         * @summary count userScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUserScenario: function (options) {
            return UserScenarioApiFp(configuration).countUserScenario(options)(axios, basePath);
        },
        /**
         * create userScenario
         * @summary create userScenario
         * @param {ModelUserScenario} body UserScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserScenario: function (body, options) {
            return UserScenarioApiFp(configuration).createUserScenario(body, options)(axios, basePath);
        },
        /**
         * delete userScenario
         * @summary delete userScenario
         * @param {number} id UserScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserScenario: function (id, options) {
            return UserScenarioApiFp(configuration).deleteUserScenario(id, options)(axios, basePath);
        },
        /**
         * get userScenario
         * @summary get userScenario
         * @param {number} id UserScenarioID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserScenario: function (id, options) {
            return UserScenarioApiFp(configuration).getUserScenario(id, options)(axios, basePath);
        },
        /**
         * patch userScenario
         * @summary patch userScenario
         * @param {number} id UserScenarioID
         * @param {ModelUserScenario} body UserScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserScenario: function (id, body, options) {
            return UserScenarioApiFp(configuration).patchUserScenario(id, body, options)(axios, basePath);
        },
        /**
         * search userScenario by search conditions
         * @summary search userScenario
         * @param {string} [nextTime] example:2006-01-02T15:04:05Z07:00
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserScenario: function (nextTime, options) {
            return UserScenarioApiFp(configuration).searchUserScenario(nextTime, options)(axios, basePath);
        },
        /**
         * update userScenario
         * @summary update userScenario
         * @param {number} id UserScenarioID
         * @param {ModelUserScenario} body UserScenario
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserScenario: function (id, body, options) {
            return UserScenarioApiFp(configuration).updateUserScenario(id, body, options)(axios, basePath);
        },
    };
};
/**
 * UserScenarioApi - object-oriented interface
 * @export
 * @class UserScenarioApi
 * @extends {BaseAPI}
 */
var UserScenarioApi = /** @class */ (function (_super) {
    __extends(UserScenarioApi, _super);
    function UserScenarioApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count userScenario by search conditions
     * @summary count userScenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserScenarioApi
     */
    UserScenarioApi.prototype.countUserScenario = function (options) {
        return UserScenarioApiFp(this.configuration).countUserScenario(options)(this.axios, this.basePath);
    };
    /**
     * create userScenario
     * @summary create userScenario
     * @param {ModelUserScenario} body UserScenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserScenarioApi
     */
    UserScenarioApi.prototype.createUserScenario = function (body, options) {
        return UserScenarioApiFp(this.configuration).createUserScenario(body, options)(this.axios, this.basePath);
    };
    /**
     * delete userScenario
     * @summary delete userScenario
     * @param {number} id UserScenarioID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserScenarioApi
     */
    UserScenarioApi.prototype.deleteUserScenario = function (id, options) {
        return UserScenarioApiFp(this.configuration).deleteUserScenario(id, options)(this.axios, this.basePath);
    };
    /**
     * get userScenario
     * @summary get userScenario
     * @param {number} id UserScenarioID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserScenarioApi
     */
    UserScenarioApi.prototype.getUserScenario = function (id, options) {
        return UserScenarioApiFp(this.configuration).getUserScenario(id, options)(this.axios, this.basePath);
    };
    /**
     * patch userScenario
     * @summary patch userScenario
     * @param {number} id UserScenarioID
     * @param {ModelUserScenario} body UserScenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserScenarioApi
     */
    UserScenarioApi.prototype.patchUserScenario = function (id, body, options) {
        return UserScenarioApiFp(this.configuration).patchUserScenario(id, body, options)(this.axios, this.basePath);
    };
    /**
     * search userScenario by search conditions
     * @summary search userScenario
     * @param {string} [nextTime] example:2006-01-02T15:04:05Z07:00
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserScenarioApi
     */
    UserScenarioApi.prototype.searchUserScenario = function (nextTime, options) {
        return UserScenarioApiFp(this.configuration).searchUserScenario(nextTime, options)(this.axios, this.basePath);
    };
    /**
     * update userScenario
     * @summary update userScenario
     * @param {number} id UserScenarioID
     * @param {ModelUserScenario} body UserScenario
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserScenarioApi
     */
    UserScenarioApi.prototype.updateUserScenario = function (id, body, options) {
        return UserScenarioApiFp(this.configuration).updateUserScenario(id, body, options)(this.axios, this.basePath);
    };
    return UserScenarioApi;
}(BaseAPI));
export { UserScenarioApi };
